
export default {
  name: 'VariantListItem',
  props: {
    product: {
      type: Object,
      required: true
    },
    variant: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    item: {
      $attrs: 'all',
      paddingY: 'xs',
      paddingX: 'sm',
      cursor: 'pointer',
      borderWidth: 1,
      borderRadius: 'lg',
      sm: {
        paddingY: 'sm'
      },
      $disabled: {
        pointerEvents(value) {
          return value ? 'none' : null
        },
        backgroundColor(value) {
          return value ? 'grey-lightest' : null
        },
        color(value) {
          return value ? 'grey-darker' : null
        }
      }
    },
    label: {
      color: 'grey-darker',
      fontSize:  'xs'
    },
    soldOut: {
      $extend: 'label',
      color: 'danger'
    },
    inStock: {
      $extend: 'label',
      color: 'success'
    },
    prevPrice: {
      fontSize: 'sm',
      color: 'grey-dark'
    },
    price: {
      fontSize: 'sm',
      fontWeight: 'bold',
      sm: {
        fontSize: 'md'
      }
    }
  },
  computed: {
    available() {
      return this.variant.totalOnHand > 0
    },
    backorderable() {
      return !this.available && this.product.backorderable
    },
    fewLeft() {
      return this.available && this.variant.totalOnHand < 10
    },
    disabled() {
      return !this.available && !this.backorderable
    },
    iconStyle() {
      const width = this.$screen.match({ all: '1.3rem', sm: '1.5rem' })
      const height = width

      return { width, height }
    }
  }
}
